<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 减重小程序端-月报页面
-->

<template>
  <div class="page-main">
    <div class="top-tip">
      长按分享或保存图片
    </div>
    <div class="report-dialog">
      <div v-if="!url" class="page-content" id="reportCon">
        <div class="title-box">
          <div class="title-text">我的</div>
          <div class="title-text">月报数据</div>
          <div class="title-time">{{startTime}}~{{ endTime }}</div>
        </div>
        <div class="d-f">
          <div class="f-box">
            <img class="box-avatar" :src="doctor" />
            <div class="box-name">医师{{ doctorName }}</div>
          </div>
          <div class="f-box">
            <img class="box-avatar" :src="dietitian" />
            <div class="box-name">营养师{{ dietitianName }}</div>
          </div>
        </div>
        <!-- 体重曲线 -->
        <div class="weight-box">
          <div class="echart-main" ref="chartColumn"></div>
          <div class="weight-header">
            <div class="header">
              <div class="title">体重</div>
              <div class="unit">单位：kg</div>
            </div>
            <div class="tab-list">
              <div @click="tabChange(0)" :class="type == 0 ? 'active tab-item' : 'tab-item'">近7天</div>
              <div @click="tabChange(1)" :class="type == 1 ? 'active tab-item' : 'tab-item'">3个月</div>
              <div @click="tabChange(2)" :class="type == 2 ? 'active tab-item' : 'tab-item'">6个月</div>
            </div>

          </div>
        </div>
        <!-- 变化记录 -->
        <div class="change-record">
          <div class="change-item">
            <div class="top-title">记录天数</div>
            <div class="bottom-num">{{ recordInfo.punchCount }}</div>
          </div>
          <div class="change-item">
            <div class="top-title">体重变化</div>
            <div class="bottom-num s-num">{{ recordInfo.weightChange || '--' }}</div>
          </div>
          <div class="change-item">
            <div class="top-title">BMI</div>
            <div class="bottom-num s-num">{{ recordInfo.bmi || '--' }}</div>
          </div>
        </div>
        <!-- 点评 -->
        <div v-for="(item, index) in commentList" :key="index">
          <div v-if="item.content">
            <div class="card-title" v-if="item.type">医师{{ doctorName }}点评</div>
            <div class="card-title" v-else>营养师{{ dietitianName }}点评</div>
            <div class="card-con">
              {{ item.content }}
            </div>
          </div>
        </div>


        <div class="share-card">
          <img class="left-img"
            src="https://pinghu-blood.oss-accelerate.aliyuncs.com/loss_image/1856252607117033473gh_c53fca4ed1dc_258.jpg?Expires=947811400084&OSSAccessKeyId=LTAI5t7QfdzJGq6FobzeHVST&Signature=qagpc7cscQXBJ9TNu8%2BMUgUIjqo%3D" />
          <div class="right">
            <div class="title">我在《营养减重服务平台》小程序记录减肥</div>
            <div class="tip">长按二维码和我一起管理体重吧！</div>
          </div>
        </div>
      </div>
      <div v-else class="img-box">
        <img :src="url" />
      </div>
      
      <div v-if="!url" class="loading"><img :src="loading" /></div>
      <!-- <div class="btn-footer">
      <div class="btn" @click="saveImg">
        保存到相册并分享
      </div>
    </div> -->
    </div>
  </div>
</template>

<script>
import ajax from '../api/ajax';
import { getQueryString } from '../api/restapi';
import { htmlToPDF } from "../utils/html2pdf";
import dietitian from '../assets/images/dietitian.jpg';
import doctor from '../assets/images/doctor.png';
import loading from '../assets/images/pending.gif'
import * as echarts from 'echarts';

var chart = null;
export default {
  data() {
    return {
      loading,
      doctor,
      dietitian,
      doctorName: "",
      dietitianName: "",
      type: 0,
      recordInfo: {},
      commentList: [],
      url: '',
    };
  },
  mounted() {
    document.title = '月报';
    this.id = getQueryString('id');
    // this.type = getQueryString('type') || 0;
    this.endTime = getQueryString('endTime');
    this.startTime = getQueryString('startTime');
    let doctorName = getQueryString('doctorName')
    this.doctorName = decodeURI(doctorName);
    let dietitianName = getQueryString('dietitianName');

    this.dietitianName = decodeURIComponent(dietitianName);
    console.log("dietitianName",dietitianName,this.dietitianName)
    this.getShareData();
  },

  methods: {
    getShareData() {
      this.getWeightList();
      this.getRecordInfo();
      this.getCommentList();
    },
    getWeightList() {
      ajax
        .Post({
          url: '/api/loss/weight/searchWeightCurve',
          data: { endTime: this.endTime, "patientId": this.id, type: this.type }
        }).then(({ data: { success, data } }) => {
          if (success && data) {
            let xAxisData = data.map(item => item.createdTime)
            let yData = data.map(item => item.score)
            let yAxis = {
              min: yData.length ? Math.min(...yData) - 1 : 0
            }
            this.initEcharts({ xAxisData, yData, yAxis })

          } else {
            this.initEcharts({ xAxisData: [], yData: [], yAxis: {} })
          }
        })
    },
    getRecordInfo() {
      ajax
        .Post({
          url: '/api/loss/punch/getPatientWeightChange',
          data: { id: this.id }
        }).then(({ data: { success, data } }) => {
          if (success) {
            let weightChange = (data.weightChange - 0).toFixed(2)
            this.recordInfo = { ...data, weightChange }
          }
        })
    },
    getCommentList() {
      ajax
        .Post({
          url: '/api/loss/punch/getComment',
          data: { patientId: this.id, date: this.startTime }
        }).then(({ data: { success, data } }) => {
          if (success) {
            this.commentList = data
          }
        })
    },
    tabChange(type) {
      this.type = type;
      this.getWeightList()
    },
    saveImg() {
      htmlToPDF('reportCon', '月报').then(url => {
        this.url = url
      });
    },
    initEcharts({ xAxisData, yData, yAxis }) {
      let that = this;
      let seriesData = [{
        type: "line",
        smooth: true,
        // top: '-330px',
        // legend:false,
        tooltip: false,
        grid: {
          right: 'right',
          bottom: 0,
          containLabel: true
        },
        data: yData,
        itemStyle: {
          normal: {
            // borderType:"dotted",
            color: "#FBB13D", //折线点的颜色
            lineStyle: {
              color: "#FBB13D" //折线的颜色
            },
            label: {
              show: true,
              color: "#FBB13D"
            } //是否在折线点上显示数字
          }
        },
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              // 渐变颜色
              {
                offset: 0,
                color: "#FBB13D"
              },
              {
                offset: 1,
                color: "#FFFFFF"
              }
            ],
            global: false
          }
        }
      }]
      let option = {
        xAxis: {
          data: xAxisData,
          axisLabel: {
            color: "#999",
            // interval: xAxisData.length - 2 //只展示起始位置
          },
          axisLine: {
            show: false
          },
          axisTick: {
            lineStyle: {
              color: "#e7e7e7"
            }
          }
        },
        yAxis: [{
          ...yAxis,
          showMaxLabel: true,
          axisLabel: {
            color: "#999",
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed"
            }
          },
        }],

        series: seriesData
      }
      if (!chart) {
        chart = echarts.init(this.$refs.chartColumn);
      }
      chart.setOption(option)
      chart.on('finished', function () {
        console.log('ECharts 图表加载完成！');
        setTimeout(() => {
          that.saveImg()
        }, 200);

        // 在这里执行你需要的操作
      });

    }
  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.loading {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 99;
  height: 100%;
  background: rgba(0, 0, 0, .2);
}

.loading img {
  width: 50px;
  height: 50px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.page-main {
  padding: 20px 10px;
  background-color: #eaedf2;
}

.d-f {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 15px;
}

.d-f .f-box {
  flex: 1;
  padding: 15px 9px;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 5px;
  border-radius: 7px;
  background-color: #fff;
}

.d-f .f-box .box-avatar {
  width: 37px;
  height: 37px;
  border-radius: 50%;
}

.d-f .f-box .box-name {
  font-size: 15px;
  color: #666666;
}

/* 页面下载内容 */
.report-dialog {
  position: relative;
  min-height: 100vh;
  height: auto;
  /* overflow: auto; */
  /* padding-bottom: 90px; */
  /* background-color: #FBB13D; */
}

.page-content {
  width: 100%;
  height: auto;
  background-color: #FBB13D;
  padding: 24px 12px;
}

.title-box {
  padding-bottom: 12px;
}

.title-box .title-text {
  font-weight: 500;
  font-size: 36px;
  color: #FFFFFF;
  line-height: 45px;
}

.title-box .title-time {
  font-size: 14px;
  color: #FFFFFF;
  line-height: 28px;
}

/* 体重曲线样式 */
.weight-box {
  width: 100%;
  height: 270px;
  position: relative;
  background-color: #fff;
  border-radius: 7px;
  overflow: hidden;
  margin-bottom: 14px;
}

.echart-main {
  width: 100%;
  height: 305px;
  padding-top: 30px;
  padding-left: 18px;
  padding-bottom: 0px;
}

.weight-header {
  position: absolute;
  top: 0;
  width: 100%;
  height: 70px;
  padding: 14px;
}

.weight-header .header,
.weight-header .tab-list {
  width: 100%;
  display: flex;
  height: 20px;
  margin-bottom: 10px;
  justify-content: space-between;
  align-items: center;
}

.weight-header .header .title {
  font-size: 15px;
  color: #333333;
}

.weight-header .header .unit {
  font-size: 11px;
  color: #999;
}

.weight-header .tab-list {
  justify-content: start;
  gap: 7px;
}

.tab-list .tab-item {
  width: 38px;
  height: 16px;
  text-align: center;
  font-size: 9px;
  color: #999;
  border-radius: 8px;
  border: 1px solid #E8E9EC;

}

.tab-list .tab-item.active {
  background: #FBB13D;
  border-color: #FBB13D;
  color: #Fff;
}

/* 变化记录 */
.change-record {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  padding: 14px 37px 14px 26px;
  background: #FFFFFF;
  border-radius: 7px;
  margin-bottom: 4px;
}

.change-record .change-item {
  height: 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

.change-record .change-item .top-title {
  font-size: 13px;
  color: #666666;
}

.change-record .change-item .bottom-num {
  font-size: 18px;
  color: #333;
}

.change-record .change-item .bottom-num.s-num {
  color: #5ED1A9;
  font-weight: 500;
}

/* 点评样式 */
.card-title {
  width: 100%;
  height: 40px;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
  line-height: 40px;
}

.card-con {
  width: 100%;
  height: auto;
  padding: 14px;
  font-size: 13px;
  color: #333333;
  line-height: 20px;
  background: #FFFFFF;
  border-radius: 7px;
  margin-bottom: 4px;
}

/* 底部分享卡片 */
.share-card {
  width: 100%;
  height: auto;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background-color: #fff;
  border-radius: 7px;
}

.share-card .left-img {
  width: 48px;
  height: 48px;
}

.share-card .right {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.share-card .right .title {
  font-size: 12px;
  color: #333333;
}

.share-card .right .tip {
  font-size: 10px;
  color: #999999;
}

/* 底部按钮 */
.btn-footer {
  position: fixed;
  bottom: 0;
  left: 0px;
  width: 100%;
  height: 83px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
  padding-bottom: 27px;
}

.btn {
  width: 343px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 1px;
  background: #FBB13D;
  border-radius: 24px;
}

.history-loading {
  width: 100%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 50%);
}


.img-box {
  width: 100%;
  height: auto;
  /* position: absolute;
  top: 0 */
}

.img-box img {
  width: 100%;
  height: auto;
}

.top-tip {
  color: #777;
  color: #FE5B59;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  padding-bottom: 20px;
}
</style>
